<template>
  <div class="c-allocationEntry">
    <div class="c-allocationEntry__title">{{ allocation.name }}</div>
    <div
      v-html="allocation.memo"
      class="ck-content c-allocationEntry__asideText"
    ></div>
    <br />
    <div
      v-if="currentUser.role == 'Admin'"
      class="c-allocationEntry__proxyNumber"
    >
      <div class="c-allocationEntry__proxyNumber__titleText">代理部屋番号:</div>
      <div>
        <Dropdown
          :options="options"
          placeholder="絞り込み"
          v-on:selected="validateSelection"
        ></Dropdown>
      </div>
      <!-- <label for="room_no" class="c-allocationEntry__proxyNumber__label">
        <select id="room_no" @change="onChangeUser" v-model="user_id">
          <option v-for="user in users" :key="user._id" :value="user._id">
            {{ user.roomNo }}
          </option>
        </select>
      </label> -->
    </div>
    <div
      v-for="(entry, index) in entries"
      :key="index"
      class="c-allocationEntry__card"
    >
      <div
        v-if="allocation.type != 'フリー' && !isMoving"
        class="c-allocationEntry__card__title"
      >
        {{ index + 1 }}台目
      </div>
      <AllocationCarEntry
        v-if="
          allocation.type == '車両' || allocation.type == '車両（総重量あり）'
        "
        :ref="'entry' + index"
        :allocation="allocation"
        :entry="entry"
        @invalid="onInvalid"
      ></AllocationCarEntry>
      <AllocationBicycleEntry
        v-else-if="allocation.type == '自転車'"
        :ref="'entry' + index"
        :allocation="allocation"
        :entry="entry"
        @invalid="onInvalid"
      >
      </AllocationBicycleEntry>
      <AllocationBikeEntry
        v-else-if="allocation.type == 'バイク'"
        :ref="'entry' + index"
        :allocation="allocation"
        :entry="entry"
        @invalid="onInvalid"
      >
      </AllocationBikeEntry>
      <AllocationMovingEntry
        v-else-if="allocation.type == '引越し'"
        :ref="'entry' + index"
        :allocation="allocation"
        :entry="entry"
        @invalid="onInvalid"
      >
      </AllocationMovingEntry>
      <AllocationFreeEntry
        v-else-if="allocation.type == 'フリー'"
        :ref="'entry' + index"
        :allocation="allocation"
        :entry="entry"
        @invalid="onInvalid"
      >
      </AllocationFreeEntry>
      <div v-else>NONE</div>
      <div>
        <div
          @click="deleteEntry(index)"
          v-if="!isFirstEntry"
          class="el-button el-button--danger"
        >
          削除
        </div>
      </div>
    </div>

    <div class="c-allocationEntry__underButtonWrap" v-if="!isMoving">
      <div
        @click="unselectedEntryAllUnnecessaryTo"
        class="el-button el-button--success"
      >
        未選択順位を一括不要
      </div>
      <div
        @click="addEntry"
        v-if="!isLastEntry"
        class="el-button el-button--primary"
      >
        追加
      </div>
    </div>
    <div class="c-allocationEntry__card__bottomButtonWrap">
      <button @click="onNext" class="el-button el-button--primary">
        この内容で申し込む
      </button>
      <div @click="onBack" class="el-button el-button--default">
        戻る
      </div>
    </div>
  </div>
</template>

<script>
import AllocationCarEntry from "@/components/AllocationCarEntry.vue";
import AllocationBicycleEntry from "@/components/AllocationBicycleEntry.vue";
import AllocationBikeEntry from "@/components/AllocationBikeEntry.vue";
import AllocationFreeEntry from "@/components/AllocationFreeEntry.vue";
import AllocationMovingEntry from "@/components/AllocationMovingEntry.vue";
import AllocationService from "@/services/allocation.service";
import AllocationEntryService from "@/services/allocation-entry.service";
import UserService from "@/services/user.service";
import Dropdown from "@/components/SearchDropdown";

const clonedeep = require("lodash/cloneDeep");

const defaultCarSpec = {
  user: null,
  allocation: null,
  spec: {
    name: "",
    length: null,
    width: null,
    height: null,
    weight: null,
    totalWeight: null,
    own: "購入予定",
  },
  entries: {},
};

const defaultBicycleSpec = {
  user: null,
  allocation: null,
  spec: {
    type: "普通",
    childSheet: 0,
  },
  entries: {},
};

const defaultFreeSpec = {
  user: null,
  allocation: null,
  spec: {},
  entries: {},
  is_agent: false,
};

export default {
  name: "AllocationEntry",
  components: {
    AllocationCarEntry,
    AllocationBicycleEntry,
    AllocationFreeEntry,
    AllocationBikeEntry,
    AllocationMovingEntry,
    Dropdown,
  },
  data() {
    return {
      maxEntry: 1,
      entries: [],
      invalid: false,
      allocation: {},
      user_id: null,
      users: [],
      dropDownDefaultValue: {},
      options: [],
    };
  },
  computed: {
    isMoving() {
      return this.allocation.type == "引越し";
    },
    isFirstEntry() {
      return this.entries.length === 1;
    },
    isLastEntry() {
      return this.entries.length === this.maxEntry;
    },
  },
  async mounted() {
    this.user_id = this.currentUser._id;
    await this.loadAllocation();
    await this.loadEntries();
    if (this.currentUser.role == "Admin") {
      await this.loadUsersInMansion();
    }
  },
  methods: {
    async validateSelection(option) {
      console.log(option);
      this.user_id = option.user_id;
      this.entries = {};
      await this.loadEntries();
      // this.user_id = option.user_id;
      // console.log(this.user_id);
      // this.entries = {};
      // await this.loadEntries();
    },
    async onChangeUser() {
      console.log("onChangeUser", this.user_id);
      this.entries = {};
      await this.loadEntries();
      // await this.loadEntries();
    },
    async loadUsersInMansion() {
      console.log("getUsersInMansion");
      const response = await UserService.findAtMansion({
        option: {
          sort: { roomNo: 1 },
          select: "roomNo",
        },
        collation: {
          locale: "en",
          numericOrdering: true,
        },
      });
      this.users = response.data;

      this.options = response.data.map((_, i) => {
        return {
          id: i + 1,
          name: _.roomNo,
          user_id: _._id,
        };
      });

      console.log("this.users", this.users);
      console.log("this.options", this.options);
    },
    async loadEntries() {
      console.log("loadEntries");
      const response = await AllocationEntryService.find({
        where: {
          allocation: this.$route.params.id,
          user: this.user_id,
        },
        option: {
          sort: { no: 1 },
        },
      });
      console.log("response=", response);
      console.log("response.data.length=", response.data.length);
      this.entries = [];
      if (response.data.length > 0) {
        console.log(1);
        this.entries = response.data;
      } else {
        console.log(2);
        this.addEntry();
      }
      console.log("+++++=", this.entries);
    },
    async loadAllocation() {
      console.log("loadAllocation");
      const response = await AllocationService.findByID(this.$route.params.id);
      this.allocation = response.data;
      console.log("allocation=", this.allocation);
      this.maxEntry = this.allocation.type == "フリー" ? 1 : 2;
    },
    unselectedEntryAllUnnecessaryTo() {
      console.log("openDialogUnselectedEntryAllUnnecessaryTo");
      const isActive = window.confirm(
        "未選択の順位を全て不要にします。よろしいですか？",
      );
      if (!isActive) return;

      console.log("unselectedEntryAllUnnecessaryTo");
      const UNNECESSARY_ENTRY_VALUE = 99999;
      const UNSELECTED_ENTRY_VALUE = "";
      this.entries.map((entrie, entrieIndex) => {
        for (const key in entrie.entries) {
          if (entrie.entries[key] === UNSELECTED_ENTRY_VALUE) {
            this.entries[entrieIndex].entries[key] = UNNECESSARY_ENTRY_VALUE;
          }
        }
      });
    },
    addEntry() {
      if (this.allocation.type == "車両") {
        let entry = clonedeep(defaultCarSpec);
        this.entries.push(entry);
      } else if (this.allocation.type == "車両（総重量あり）") {
        let entry = clonedeep(defaultCarSpec);
        this.entries.push(entry);
      } else if (this.allocation.type == "自転車") {
        let entry = clonedeep(defaultBicycleSpec);
        this.entries.push(entry);
      } else {
        let entry = clonedeep(defaultFreeSpec);
        this.entries.push(entry);
      }
    },
    deleteEntry(index) {
      if (confirm("削除しても良いですか？") === false) {
        return;
      }
      console.log("deleteEntry", index);
      this.entries.splice(index, 1);
      console.log(this.entries);
    },
    onBack() {
      this.$router.push({ name: "allocation-index" });
    },
    async onNext() {
      console.log("onNext");
      let totalInvalid = 0;
      for (let index = 0; index < this.entries.length; index++) {
        const refName = "entry" + index;
        this.$refs[refName][0].$v.$touch();
        const invalid = this.$refs[refName][0].$v.$invalid;
        console.log("invalid=", invalid);
        if (invalid) {
          totalInvalid++;
        }
      }
      console.log("totalInvalid=", totalInvalid);
      if (totalInvalid > 0) {
        this.$message({
          message: "入力エラーがあります。",
          type: "error",
        });
        return;
      }
      if (confirm("この内容で申し込みます。よろしいですか。") === false) {
        return;
      }
      const response = await AllocationEntryService.entries(
        this.$route.params.id,
        {
          user_id: this.user_id,
          entries: this.entries,
          is_agent: this.currentUser._id != this.user_id,
        },
      );
      console.log("response=", response);
      // this.$router.push("/allocation/confirm");
      this.$router.push({
        name: "allocation-complated",
        params: { id: this.$route.params.id },
      });
    },
    onInvalid(value) {
      console.log("onInvalid >>", value);
      // if (!this.invalid) {
      //   this.invalid = value;
      // }
    },
  },
};
</script>
